module.exports = __webpack_public_path__ + "img/stocktrim.cbb07e00.jpeg";